// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import 'font-awesome/css/font-awesome.min.css'
import VueResource from 'vue-resource'
import './style/globel.css'
import apiurl from './util'
import VueForm from 'vue-form'
import VueClipboard from 'vue-clipboard2'
import VueEditor from 'vue2-editor'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/django/django'
import 'codemirror/theme/blackboard.css'
import {CommonUtils} from './utils/base_apis'

Vue.use(VueForm)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(VueEditor)
Vue.config.productionTip = false
Vue.http.options.emulateJSON = true
Vue.prototype.$apiurl = apiurl.apiurl
Vue.prototype.$apiUrl = apiurl.apiurl
Vue.prototype.$signurl = apiurl.signurl
Vue.http.options.xhr = {withCredentials: true}
Vue.http.options.crossOrigin = true
Vue.http.options.emulateHTTP = true
Vue.http.options.withCredentials = true
Vue.use(VueClipboard)
Vue.use(VueCodemirror)
/* eslint-disable no-new */

var loader

Vue.prototype.$pageloading = function () {
  loader = this.$loading({
    lock: true,
    text: '请求处理中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

Vue.prototype.$loadend = function () {
  try {
    loader.close()
  } catch (e) {
    console.log('close')
  }
  loader = ''
}

Vue.prototype.$datefeed = function (time) {
  var d = new Date(time)
  return d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
}

Vue.prototype.$verifyhead = {Authorization: 'Token ' + localStorage.getItem('token')}

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token')) {
    Vue.http.headers.common['Authorization'] = 'Token ' + localStorage.getItem('token')
  }
  next()
})

Vue.http.interceptors.push(function (request, next) {
  var that = this
  if (request.method === 'POST' && request.body.method !== 'base.getmenu') {
    next(function (response) {
      if (response.body.code === 909 && that.$route.path !== '/admin/sso') {
        window.location.href = CommonUtils.getSsoUrl(window.location.href)
      } else {
        return response
      }
    })
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js